/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, OnDestroy, Renderer2, RendererFactory2 } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
// import { Http, Headers, Response } from '@angular/http';
import { Title } from '@angular/platform-browser';
import packageInfo from '../../../package.json';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { snakeCaseToHumanReadable } from 'src/app/_services/flows/helpers.functions';
import { SubscriptionsManager } from './subscriptions-manager.service';
import { TimeoutsManager } from './timeouts-manager.service';

// import {
//   CollectionReference,
//   DocumentData,
//   addDoc,
//   setDoc,
//   collection,
//   deleteDoc,
//   getDocs,
//   doc,
//   updateDoc,
//   query as qry,
//   where,
//   or,
//   startAt,
//   startAfter,
//   limit,
//   limitToLast,
//   orderBy,
//   getDoc,
//   onSnapshot,
//   WhereFilterOp,
//   getCountFromServer
// } from '@firebase/firestore';


// import { HttpClient } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject, filter, map } from 'rxjs';
// import { takeUntil } from 'rxjs/operators';
import { TWADialogsService } from '../_services/twa-dialogs.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ServerConn } from './serverConn.service';
import { DateHelper } from '../_services/date-helper.service';

// import { Firestore } from '@angular/fire/firestore';
// import {
//   collection,
//   query,
//   where,
//   onSnapshot,
// } from '@firebase/firestore';

import { FirestoreDbService } from './firestore-db.service';
import { LazyDialogService } from '../_services/lazy-dialog.service';
import { doc } from 'rxfire/firestore';
// import { WindowRef } from './windowref.service';
// import { V } from '@angular/cdk/keycodes';
// import { collection } from 'rxfire/firestore';

@Injectable({
  providedIn: 'root'
})
export class AppService implements OnDestroy {
  appTitle = 'Mail Automation';
  shortTitle = 'MA';
  appSubTitle = '';
  comunidades = [];
  auth: any = {};
  user: any = {};
  version: string = packageInfo.version;
  selectedClient: any = false;
  clients: any[] = [];
  clientsLoaded = false;
  invitations: any = [];
  campaigns: any[] = [];
  lists: any[] = [];
  flows: any[] = [];
  profiles: any[] = [];
  templates: any[] = [];
  popups: any[] = [];
  loaded: any = {
    campaigns: false,
    lists: false,
    flows: false,
    profiles: false,
    templates: false,
    popups: false
  };
  statsCampaigns: any = {};
  bearerToken: string = '';
  dbData: any = {
    profiles: {
      total: 0,
      last: false,
      totalFiltered: 0,
    }
  };
  currency_base = 'EUR';
  deviceType: any = 'desktop';
  selectingClient = false;
  integrationTypes: any[] = [
    {
      id: 1,
      name: 'Wordpress',
      fullIntegration: true,
      callUrl: false,
      show: true,
    },
    {
      id: 2,
      name: 'Shopify',
      fullIntegration: true,
      callUrl: false,
      show: false,
    },
    {
      id: 3,
      name: 'Terceros (API Key)',
      fullIntegration: false,
      callUrl: false,
      show: true,
    },
    {
      id: 4,
      name: 'Hubspot',
      fullIntegration: false,
      callUrl: 'https://app-eu1.hubspot.com/oauth/144490803/authorize?client_id=aa3f69e2-09c8-4fc0-bd21-a8be7e94c315&redirect_uri=https://hs.nvio.ai/install&scope=crm.objects.contacts.write%20crm.objects.contacts.read&state=<api_key>',
      buttonText: 'Instalar',
      show: true,
    },
  ];
  theme = 'light';
  isDark = false;
  spinnerMsg = 'Por favor, espere...';
  lastSpinnerMsg = 'Por favor, espere...';
  formsAppearance: any = 'fill';
  flowsDirection: any = 't2b';
  updateTheme$: BehaviorSubject<boolean> = new BehaviorSubject(this.isDark);
  allProfileColumns: any[] = [];
  allProfileColumnsLoaded = false;
  shopifyColumns: any[] = [];
  allProfileColumnLabels: any = {};

  now: any = new Date();
  dateRangeChanged: BehaviorSubject<any> = new BehaviorSubject(true);
  dateRange = {
    start: new Date(),
    end: new Date(),
  };
  customDate = false;
  selectedDays = 0;
  showDateRange = false;
  loadingProfiles = false;

  previousUrl: string = '';
  currentUrl: string = '';
  queries: any = {
    profiles: {
      page: -1,
      query: -1,
      order: -1,
      pageSize: -1,
      client: -1
    }
  };
  // currencies: any[] = [
  //   {
  //     label: 'EUR',
  //     symbol: '€'
  //   },
  //   {
  //     label: 'USD',
  //     symbol: '$'
  //   },
  // ]
  getCurrencySymbol = (locale: any, currency: any) => (0).toLocaleString(locale, { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\d/g, '').trim();
  currencies: any[] = (Intl as any).supportedValuesOf("currency").map((value: any) => {
    return {
      label: value,
      symbol: this.getCurrencySymbol(navigator.language || (navigator as any).browserLanguage, value)
    }
  });

  stats: any = {
    num_profiles: {
      label: 'Num. perfiles',
      value: 'N/A',
    },
    profiles_last_week: {
      label: 'Perfiles últ. semana',
      value: 'N/A',
    },
    emails_last_24h: {
      label: 'Enviados últ. 24h',
      value: 'N/A',
    },
    opened_last_24h: {
      label: 'Abiertos últ. 24h',
      value: 'N/A',
    },
    clicks_last_24h: {
      label: 'Clicks últ. 24h',
      value: 'N/A',
    },
    buys_value: {
      label: 'Valor de compra',
      value: 'N/A',
    },
    open_ratio: {
      label: 'Ratio de apertura',
      value: 'N/A',
    },
    click_ratio: {
      label: 'Ratio de clicks',
      value: 'N/A',
    },
  };
  statsLabels: any = [
    'num_profiles',
    'profiles_last_week',
    'emails_last_24h',
    'opened_last_24h',
    'clicks_last_24h',
    'buys_value',
    'open_ratio',
    'click_ratio',
  ];
  statsCampaignsLabelsArray: any = [
    'uniq_mta_enqueued',
    'percent_delivered',
    'percent_readed',
    'percent_clicked',
    'percent_unsubscribed',
    'percent_bounced',
    'orders'
  ];
  statsCampaignsLabels: any = {
    uniq_mta_enqueued: {
      label: 'Perfiles',
      value1: 'uniq_mta_enqueued',
      value2: '',
    },
    percent_delivered: {
      label: 'Entregados',
      value1: 'percent_delivered',
      value2: 'uniq_delivered',
    },
    percent_readed: {
      label: 'Abiertos',
      value1: 'percent_readed',
      value2: 'uniq_readed',
    },
    percent_clicked: {
      label: 'Clicks',
      value1: 'percent_clicked',
      value2: 'uniq_clicked',
    },
    percent_unsubscribed: {
      label: 'Anulaciones',
      value1: 'percent_unsubscribed',
      value2: 'uniq_unsubscribed',
    },
    percent_bounced: {
      label: 'Rebotes',
      value1: 'percent_bounced',
      value2: 'uniq_bounced',
    },
    orders: {
      label: 'Orders',
      value1: 'orders',
      value2: 'orders_value',
      // suffix1: this.appSvc.currencies.filter(v => v.label == this.appSvc.selectedClient.currency)[0].symbol,
      // suffix2: this.currencies.filter(v => v.label == this.selectedClient.currency)[0].symbol,
      hideIfEmpty: true
    },
  };
  sendingProfiles = false;

  appData: any = {};

  updateLists: BehaviorSubject<boolean> = new BehaviorSubject(false);
  updateData: BehaviorSubject<any> = new BehaviorSubject({});
  private unsubscribe: Subject<boolean> = new Subject();
  private unsubscribeData: any = {
    campaigns: false,
    lists: false,
    flows: false,
    profiles: false,
    templates: false,
    popups: false,
  };

  fontsInstalled: any[] = [];

  subscriptions = new SubscriptionsManager();
  timeouts = new TimeoutsManager();

  loadingData: any = {
    campaigns: true,
    lists: true,
    flows: true,
    profiles: true,
    templates: true,
    popups: true,
    loading: true,
    firstLoad: true,
    timeout: false,
    // loading: () => !this.loadingData.campaigns || !this.loadingData.lists || !this.loadingData.flows || !this.loadingData.profiles || !this.loadingData.templates || !this.loadingData.popups,
    set(data: string, value: boolean) {
      if (this[data]) {
        this[data] = value;
      }
      if (this.campaigns || this.lists || this.flows || this.profiles || this.templates || this.popups) {
        this.loading = true;
      } else {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
          this.loading = false;
          this.firstLoad = false;
        }, 500);
      }
    }
  };
  logged = false;
  clipboard: any = {};
  tawkInitiated = false;
  renderer!: Renderer2;
  clientFilled: any = '';
  onMidnight$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    // private windowref: WindowRef,
    // private httpClient: HttpClient,
    // private firestore: Firestore,
    private titleSvc: Title,
    private afAuth: AngularFireAuth,
    private lazyDialogSvc: LazyDialogService,
    // private windowRef: WindowRef,
    private dbSvc: FirestoreDbService,
    private server: ServerConn,
    private spinnerSvc: NgxSpinnerService,
    public dlgsSvc: TWADialogsService,
    public snackBar: MatSnackBar,
    public dateHelper: DateHelper,
    private rendererRactory: RendererFactory2,
  ) {
    this.renderer = this.rendererRactory.createRenderer(null, null);
    this.now.setDate(this.now.getDate() - 7);
    this.dateRange.start = this.now;
    /**
     * DateRange
     */
    let savedDateRange: any = localStorage.getItem('dateRange');
    console.log('🚀 ~ AppService ~ constructor ~ savedDateRange:', savedDateRange);
    const selectedDays = localStorage.getItem('selectedDays');
    console.log('🚀 ~ AppService ~ constructor ~ selectedDays:', selectedDays);
    if (selectedDays) {
      this.selectedDays = parseInt(selectedDays);
    }
    if (savedDateRange) {
      savedDateRange = JSON.parse(savedDateRange);
      this.updateDateRange(savedDateRange, false);
    }
    const formsTheme = localStorage.getItem('formsTheme');
    if (formsTheme) {
      this.formsAppearance = formsTheme;
    }
    this.subscriptions.add(
      this.router.events.pipe(
        filter((event: any) => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }),
      'constructor1'
    );
    this.subscriptions.add(
      this.afAuth.authState.subscribe((res: any) => {
        if (res) {
          this.logged = true;
        } else {
          this.logged = false;
        }
      }),
      'constructor2'
    );
    this.flowsDirection = localStorage.getItem('flowsDirection') || this.flowsDirection;
    this.getFields();
  }

  async loadClient() {
    const selectedClientField = this.user.id + '-' + 'selectedClient';
    const client = localStorage.getItem(selectedClientField);
    if (client) {
      this.selectedClient = JSON.parse(client);
      if (!this.selectedClient.currency || this.selectedClient.currency == undefined) {
        this.selectedClient.currency = this.currency_base;
      }
      const res = await this.dbSvc.get('clients', this.selectedClient.id);
      if (res.exists()) {
        this.selectedClient = res.data();
        this.updateData.next({
          type: 'selectedClient',
          data: this.selectedClient
        });
        let currency = this.currencies.filter(v => {
          if (v.label == this.selectedClient.currency) {
            return true;
          }
          return false;
        })[0];
        if (!currency) {
          currency = {
            symbol: this.currency_base
          };
        }
        this.selectedClient.currency_symbol = this.currencies.filter((v: any) => v.label == this.selectedClient.currency)[0]?.symbol || 'EUR';
        this.statsCampaignsLabels.orders.suffix2 = currency.symbol
        this.getClientAccount();
      } else {
        this.selectClient();
      }

      // this.dbSvc.get('clients', this.selectedClient.id).then((res: any) => {
      //   if (res.exists()) {
      //     this.selectedClient = res.data();
      //     this.updateData.next({
      //       type: 'selectedClient',
      //       data: this.selectedClient
      //     });
      //     this.getClientAccount();
      //   } else {
      //     this.selectClient();
      //   }
      // }, (err: any) => {
      //   if (this.auth.uid) {
      //     this.selectClient();
      //   }
      // });
    } else if (this.auth.uid) {
      this.selectClient();
    } else {
      console.log('🚀 ~ AppService ~ not client');
    }
  }

  genStats() {
    this.genStatsCampaigns();
    this.genStatsProfiles();
  }

  isOwner() {
    return this.user.id == this.selectedClient.owner;
  }

  startSpinner(msg: string = this.spinnerMsg) {
    this.lastSpinnerMsg = this.spinnerMsg;
    if (msg !== this.spinnerMsg) {
      this.spinnerMsg = msg;
    }
    this.spinnerSvc.show();
  }

  getExecInfo() {
    const err = new Error();
    const regex = /.*at\s+([^\s]+)\s\([^:]+:[^:]+:[^:]+:([^:]+)/g
    if (!err.stack) {
      err.stack = '';
    }
    let ret: any = [...err.stack.matchAll(regex)];

    return ret;
    // return [ret[0][1], ret[0][2]];
    // return [...err.stack.split("\n")[1]];
  }

  stopSpinner() {
    this.spinnerMsg = this.lastSpinnerMsg;
    this.spinnerSvc.hide();
  }

  getViewSettings(type: any) {
    if (!this.selectedClient) {
      this.timeouts.add(
        setTimeout(() => {
          this.getViewSettings(type);
        }, 500)
      );
      return;
    }
    if (type == 'popups') {
      if (!this.selectedClient.settings || !this.selectedClient.settings.popups) {
        this.dbSvc.get(`clients/${this.selectedClient.id}/settings`, 'popups').then((ref: any) => {
          console.log('🚀 ~ this.dbSvc.get ~ ref:', ref);
          if (ref.exists()) {
            if (!this.selectedClient.settings) {
              this.selectedClient.settings = {};
            }
            const data = ref.data();
            this.selectedClient.settings.popups = data;
            this.updateData.next({
              type: 'popupsSettings',
              data: this.selectedClient
            });
            console.log('🚀 ~ this.dbSvc.get ~ this.selectedClient.settings.popups:', this.selectedClient.settings.popups);
          }
        });
      }
    }
  }

  updateDateRange(range: any, fromDateRange = true) {
    if (range.start) {
      this.customDate = true;
      this.dateRange.start = range.start;
      this.dateRange.end = range.end;

      this.dateRangeChanged.next(this.dateRange);
    } else if (typeof range == 'number' && range > 0) {
      this.customDate = false;
      this.selectedDays = range;
      // this.dateRange.start = new Date();
      // this.dateRange.end = new Date();
      // const offset = (24 * 60 * 60 * 1000);
      // this.dateRange.end.setTime(this.dateRange.end.getTime() + offset);
      // this.dateRange.start.setDate(this.dateRange.start.getDate() - range);
      // this.dateRange.start.setTime(this.dateRange.start.getTime() - (offset * range));
    }
    localStorage.setItem('selectedDays', this.selectedDays.toString());
    if (fromDateRange) {
      localStorage.setItem('dateRange', JSON.stringify(this.dateRange));
    } else {
      localStorage.removeItem('dateRange');
    }
    this.getCampaigns();
  }

  getValidDateWithHour(isoString: string, hour: any) {
    // Verificar que la entrada sea un string válido en formato ISO
    if (typeof isoString !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(isoString)) {
      return isoString;
    }

    const newDate = new Date(isoString);
    hour = hour.split(':');
    newDate.setHours(+hour[0]);
    newDate.setMinutes(+hour[1]);

    return newDate.toISOString();
  }

  setTheme() {
    if (this.theme === 'light') {
      localStorage.setItem('theme', 'light');
      document.body.classList.remove('darkTheme'); // Remove darkMode
      this.isDark = false;
    } else if (this.theme === 'dark') {
      localStorage.setItem('theme', 'dark');
      document.body.classList.add('darkTheme'); // Add darkMode
      this.isDark = true;
    }
  }

  genStatsCampaigns() {
    const data: any = {
      clicked: 0,
      opened: 0,
      sended: 0,
      bounced: 0,
    };
    this.stats.open_ratio.value = 'N/A';
    this.stats.click_ratio.value = 'N/A';
    this.campaigns.forEach((campaign: any) => {
      data.sended += campaign.stats?.uniq_mta_enqueued || 0;
      data.clicked += campaign.stats?.uniq_clicked || 0;
      data.opened += campaign.stats?.uniq_readed || 0;
      data.bounced += campaign.stats?.uniq_bounced || 0;
    });
    if (data.sended > 0) {
      this.stats.sended = data.opened;
      this.stats.opened = data.opened;
      this.stats.clicked = data.clicked;
      this.stats.bounced = data.bounced;
      this.stats.open_ratio.value = (data.opened / data.sended).toFixed(2);
      this.stats.click_ratio.value = (data.clicked / data.sended).toFixed(2);
    }
  }

  genStatsProfiles() {
    this.stats.num_profiles.value = this.dbData.profiles.total || 'N/A';
    this.stats.profiles_last_week.value = this.profiles.filter((profile: any) => {
      if (!profile.created) {
        return false;
      }
      const profDate = new Date(profile.created);
      const now = new Date();
      return now.getDate() - profDate.getDate() <= 7;
    }).length;
    this.stats.emails_last_24h.value = this.profiles.filter((profile: any) => {
      if (!profile.last_mta_enqueue) {
        return false;
      }
      const profDate = new Date(profile.last_mta_enqueue.seconds * 1000);
      const now = new Date();
      return now.getDate() - profDate.getDate() <= 1;
    }).length;
    this.stats.opened_last_24h.value = this.profiles.filter((profile: any) => {
      if (!profile.last_readed) {
        return false;
      }
      const profDate = new Date(profile.last_readed.seconds * 1000);
      const now = new Date();
      return now.getDate() - profDate.getDate() <= 1;
    }).length;
    this.stats.clicks_last_24h.value = this.profiles.filter((profile: any) => {
      if (!profile.last_clicked) {
        return false;
      }
      const profDate = new Date(profile.last_clicked.seconds * 1000);
      const now = new Date();
      return now.getDate() - profDate.getDate() <= 1;
    }).length;
  }

  getClientAccount() {
    this.dbSvc.get('accounts', this.selectedClient.id).then((res: any) => {
      if (res.exists()) {
        this.selectedClient.account = res.data();
        // const until = new Date(this.selectedClient.account.plan_until.seconds*1000).toISOString();
        const until: Date = this.selectedClient.account.plan_until.toDate();
        if (until.toISOString() < new Date().toISOString()) {
          this.selectedClient.account.expired = true;
        }
      }
    });
  }

  async getUser(user: any) {
    if (!user) {
      let url: any = window.location.href.replace('http://', '').replace('https://', '');
      url = url.split('/');
      delete url[0];
      url = [...url];
      url = url.join('/');
      this.router.navigateByUrl('/login?returnUrl=' + encodeURI(url));
      // this.router.navigateByUrl('/login?returnUrl=' + this.router.url);
      return;
    } else if (user.uid && this.auth && this.auth.uid && user.uid == this.auth.uid) {
      return;
    }
    let usr: any = {};
    try {
      usr = (await this.dbSvc.get('users', user.uid)).data();
    } catch (e: any) {
      this.timeouts.add(
        setTimeout(() => {
          this.getUser(user);
        }, 1000),
        'getUser1'
      );
      return;
    }
    if (usr) {
      this.auth = user;
      // if (!user.photoURL || user.photoURL == '') {
      //   this.auth.set('photoURL', 'assets/icons/user.png');
      // }
      this.user = usr;
      await this.dbSvc.checkIsAdmin(this.user).then((isAdmin: boolean) => {
        this.user.superuser = isAdmin;
        this.updateData.next({
          type: 'user',
          data: this.user
        });
      });
      // if (!this.auth.photoURL || this.auth.photoURL == '') {
      //   this.auth.photoURL = 'assets/icons/user.png';
      // }
      this.auth.id = this.auth.uid;
      if (usr.active) {
        this.dbSvc.auth = this.auth;
        this.clientsLoaded = false;
        this.clients = await this.dbSvc.getAllClients();
        this.clientsLoaded = true;
        this.loadClient();
        // setTimeout(() => {
        if (this.clients.length) {
          this.updateData.next({
            type: 'clients',
            data: this.clients
          });
          if (!this.selectedClient && this.user && this.user.user_type !== 'shopify') {
            this.selectClient();
          }
        } else {
          this.selectClient();
        }
        // }, 800);
        const filter = [
          {
            fld: 'email_user',
            op: '==',
            val: this.auth.email
          }
        ];
        this.dbSvc.queryCollection('invitations', filter).then((res: any) => {
          res.forEach((res2: any) => {
            this.invitations.push(res2.data());
          })
        });
        if (this.selectedClient) {
          this.timeouts.add(
            setTimeout(() => {
              this.dbData.profiles.total = 0;
              this.fillClient();
            }, 500),
            'getUser2'
          );
        }
        // } else {
        //   this.clientsLoaded = false;
        //   this.clients = await this.dbSvc.getAllClients();
        //   this.clientsLoaded = true;
        //   if (this.clients.length) {
        //     setTimeout(() => {
        //       this.getUser(user);
        //     }, 1000);
        //   } else {
        //     this.selectClient();
        //   }
      }
    } else {
      this.timeouts.add(
        setTimeout(() => {
          this.getUser(user);
        }, 1000),
        'getUser3'
      );
    }

  }

  initTawk() {
    if (this.tawkInitiated) {
      return;
    }
    const src = document.location.hostname == 'app.nvio.ai' || document.location.hostname == 'app-beta.nvio.ai' ? '6627a484a0c6737bd12f5a3b' : '656cdaedff45ca7d478673c3';
    const param = document.location.hostname == 'app.nvio.ai' || document.location.hostname == 'app-beta.nvio.ai' ? '1hs5dl9ls' : '1hgojecji';
    // const param = document.location.hostname == 'app.nvio.ai' ? '1hgojecji' : '1hs5dl9ls';
    const script = `
    var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
    (function () {
      var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = 'https://embed.tawk.to/${src}/${param}';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
      s0.parentNode.insertBefore(s1, s0);
    })();
    Tawk_API.onLoad = function() {
      Tawk_API.hideWidget();
    };`;
    const script2 = `
    var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
    (function(){
    var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
    s1.async=true;
    s1.src='https://embed.tawk.to/656cdaedff45ca7d478673c3/1hgojecji';
    s1.charset='UTF-8';
    s1.setAttribute('crossorigin','*');
    s0.parentNode.insertBefore(s1,s0);
    })();
    </script>
    <!--End of Tawk.to Script-->
    `;
    const el = this.renderer.createElement('script');
    el.text = script;
    this.renderer.appendChild(document.body, el);
  }

  changeClient(client: any) {
    this.selectedClient = client;
    this.updateData.next({
      type: 'selectedClient',
      data: this.selectedClient
    });
    this.getClientAccount();
  }

  updateTheme(isDark: boolean) {
    this.isDark = isDark;
    this.updateTheme$.next(this.isDark);
  }

  selectClient() {
    if (this.clientsLoaded && !this.selectingClient && this.user && this.user.user_type !== 'shopify') {
      // console.trace('🚀 ~ AppService ~ selectClient ~ this.user:', this.user);
      this.selectingClient = true;
      this.lazyDialogSvc.openDialog('client-select').then((dlgRef: any) => {
        this.subscriptions.add(
          dlgRef.afterClosed().subscribe((res: any) => {
            if (res) {
              this.selectingClient = false;
              const selectedClientField = this.user.id + '-' + 'selectedClient';
              localStorage.setItem(selectedClientField, JSON.stringify(this.selectedClient));
              this.updateData.next({
                type: 'selectedClient',
                data: this.selectedClient
              });
            }
          }),
          'selectClient1'
        );
      });
      // } else if (!this.clientsLoaded) {
      //   setTimeout(() => {
      //     this.selectClient();
      //   }, 1000);
    }
  }

  async fillClient() {
    if (!this.selectedClient || !this.selectedClient.id) {
      this.timeouts.add(
        setTimeout(() => {
          this.fillClient();
        }, 500),
        'fillClient1'
      );
      return;
    }
    let data: any = [];
    this.dbData.profiles.total = 0;
    this.dbData.profiles.totalFiltered = 0;
    this.getCampaigns();
    this.getLists();
    this.getFlows();
    this.getProfilesSummary();
    // this.getProfiles();
    this.getTemplates();
    this.getPopups();
    this.clientFilled = this.selectedClient.id;
    this.updateData.next({
      type: 'client_filled',
      data: this.selectedClient
    });
    this.genStats();
    // this.updateData.next(true);
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
    this.updateData.complete();
    if (this.unsubscribeData.campaigns) {
      this.unsubscribeData.campaigns();
    }
    if (this.unsubscribeData.lists) {
      this.unsubscribeData.lists();
    }
    if (this.unsubscribeData.profiles) {
      this.unsubscribeData.profiles();
    }
    this.subscriptions.unsubscribeAll();
    this.timeouts.clearAll();
  }

  getClientCurrency() {
    return this.selectedClient.currency || this.currency_base;
  }

  getClientById(id: string) {
    const client = this.clients.filter(c => c.id === id);
    if (client.length) {
      return client[0];
    }
    return false;
  }

  async getCampaigns() {
    if (this.unsubscribeData.campaigns) {
      this.unsubscribeData.campaigns();
    }
    this.loaded.campaigns = -1;
    this.loadingData.campaigns = true;
    this.loadingData.set('campaigns', true);
    const whereConds: any[] = [];
    if (this.customDate == false) {
      const date = new Date();
      date.setDate(date.getDate() - this.selectedDays);
      date.setHours(0, 0, 0, 0);
      whereConds.push({
        fld: 'created',
        op: '>=',
        val: this.dateHelper.format(date, 'yyyy-MM-dd HH:mm:ss')
      });

      const endDate = new Date(Date.now() + 24 * 60 * 60 * 1000);
      endDate.setHours(23, 59, 59, 999); // Establecer al final del día
      whereConds.push({
        fld: 'created',
        op: '<=',
        val: this.dateHelper.format(endDate, 'yyyy-MM-dd HH:mm:ss')
      });
    } else {
      whereConds.push({
        fld: 'created',
        op: '>=',
        val: this.dateHelper.format(this.dateRange.start, 'yyyy-MM-dd HH:mm:ss')
      });
      whereConds.push({
        fld: 'created',
        op: '<=',
        val: this.dateHelper.format(this.dateRange.end, 'yyyy-MM-dd HH:mm:ss')
      });
    }
    this.unsubscribeData.campaigns = this.dbSvc.getSubcollectionSnapshot('clients/' + this.selectedClient.id, 'campaigns', (ref: any) => {
      const campaigns: any[] = [];
      ref.forEach((campaignRef: any) => {
        const campaign = campaignRef.data();
        if (!campaign.status || campaign.status == '') {
          campaign.status = 'draft';
        }
        campaigns.push(campaign);
      });
      this.statsCampaigns = {};
      this.campaigns = campaigns.sort((a: any, b: any) => {
        if (a.created === b.created) {
          return 0;
        }
        return a.created < b.created ? 1 : -1;
      }).map((campaign: any) => {
        if (campaign.stats) {
          const keys = Object.keys(campaign.stats);
          keys.forEach((key: any) => {
            if (!this.statsCampaigns[key]) {
              this.statsCampaigns[key] = 0;
            }
            this.statsCampaigns[key] += campaign.stats[key];
          });
          keys.forEach((key: any) => {
            if (!isNaN(+this.statsCampaigns[key])) {
              this.statsCampaigns[key] = +this.statsCampaigns[key].toFixed(2);
            }
          });
          if (campaign.stats.uniq_delivered && campaign.stats.uniq_mta_enqueued) {
            campaign.stats.percent_delivered = (campaign.stats.uniq_delivered / campaign.stats.uniq_mta_enqueued * 100).toFixed(2) + '%';
          } else {
            campaign.stats.percent_delivered = 'N/A';
          }
          if (campaign.stats.uniq_readed && campaign.stats.uniq_delivered) {
            campaign.stats.percent_readed = (campaign.stats.uniq_readed / campaign.stats.uniq_delivered * 100).toFixed(2) + '%';
          } else {
            campaign.stats.percent_readed = 'N/A';
          }
          if (campaign.stats.uniq_clicked && campaign.stats.uniq_delivered) {
            campaign.stats.percent_clicked = (campaign.stats.uniq_clicked / campaign.stats.uniq_delivered * 100).toFixed(2) + '%';
          } else {
            campaign.stats.percent_clicked = 'N/A';
          }
          if (campaign.stats.uniq_unsubscribed && campaign.stats.uniq_mta_enqueued) {
            campaign.stats.percent_unsubscribed = (campaign.stats.uniq_unsubscribed / campaign.stats.uniq_mta_enqueued * 100).toFixed(2) + '%';
          } else {
            campaign.stats.percent_unsubscribed = 'N/A';
          }
          if (campaign.stats.uniq_bounced && campaign.stats.uniq_mta_enqueued) {
            campaign.stats.percent_bounced = (campaign.stats.uniq_bounced / campaign.stats.uniq_mta_enqueued * 100).toFixed(2) + '%';
          } else {
            campaign.stats.percent_bounced = 'N/A';
          }
          // if (campaign.stats.orders && campaign.stats.orders) {
          //   campaign.stats.orders = campaign.stats.orders.toFixed(2);
          // }
          if (campaign.stats.orders_value && campaign.stats.orders_value) {
            campaign.stats.orders_value = campaign.stats.orders_value.toFixed(2);
          }
        }
        return campaign;
      });
      if (this.statsCampaigns.uniq_delivered && this.statsCampaigns.uniq_mta_enqueued) {
        this.statsCampaigns.percent_delivered = (this.statsCampaigns.uniq_delivered / this.statsCampaigns.uniq_mta_enqueued * 100).toFixed(2) + '%';
      } else {
        this.statsCampaigns.percent_delivered = 'N/A';
      }
      if (this.statsCampaigns.uniq_readed && this.statsCampaigns.uniq_delivered) {
        this.statsCampaigns.percent_readed = (this.statsCampaigns.uniq_readed / this.statsCampaigns.uniq_delivered * 100).toFixed(2) + '%';
      } else {
        this.statsCampaigns.percent_readed = 'N/A';
      }
      if (this.statsCampaigns.uniq_clicked && this.statsCampaigns.uniq_delivered) {
        this.statsCampaigns.percent_clicked = (this.statsCampaigns.uniq_clicked / this.statsCampaigns.uniq_delivered * 100).toFixed(2) + '%';
      } else {
        this.statsCampaigns.percent_clicked = 'N/A';
      }
      if (this.statsCampaigns.uniq_unsubscribed && this.statsCampaigns.uniq_mta_enqueued) {
        this.statsCampaigns.percent_unsubscribed = (this.statsCampaigns.uniq_unsubscribed / this.statsCampaigns.uniq_mta_enqueued * 100).toFixed(2) + '%';
      } else {
        this.statsCampaigns.percent_unsubscribed = 'N/A';
      }
      if (this.statsCampaigns.uniq_bounced && this.statsCampaigns.uniq_mta_enqueued) {
        this.statsCampaigns.percent_bounced = (this.statsCampaigns.uniq_bounced / this.statsCampaigns.uniq_mta_enqueued * 100).toFixed(2) + '%';
      } else {
        this.statsCampaigns.percent_bounced = 'N/A';
      }
      this.loadingData.campaigns = false;
      this.loadingData.set('campaigns', false);
      this.loaded.campaigns = true;
      this.updateData.next({
        type: 'campaigns',
        data: this.campaigns
      });
    }, null, null, null, whereConds);

  }

  async getLists() {

    if (this.unsubscribeData.lists) {
      this.unsubscribeData.lists();
    }
    this.loaded.lists = -1;
    this.loadingData.lists = true;
    this.loadingData.set('lists', true);
    this.unsubscribeData.lists = this.dbSvc.getSubcollectionSnapshot('clients/' + this.selectedClient.id, 'lists', (ref: any) => {
      const lists: any[] = [];
      for (let i = 0, l = ref.size; i < l; i++) {
        const listRef = ref.docs[i];
        const list = listRef.data();
        if (list.id) {
          this.dbSvc.queryCollectionCount(
            'clients/' + this.selectedClient.id + '/profiles',
            [
              {
                fld: 'lists',
                op: 'array-contains',
                val: list.id
              }
            ]
          ).then((count: any) => {
            list.profiles_count = count.data().count;
            list.created = list.created ? list.created.split('T').map((v: any, i: number) => i == 0 ? this.mirrorDate(v) : v).join(' ').substring(0, 19) : '';
            lists.push(list);
          });
        }
      }
      /**
       * TODO: Revisar porqué no funciona OrderBy en el snapshot
       */
      this.lists = lists.sort((a: any, b: any) => {
        if (a.name === b.name) {
          return 0;
        }
        return a.name > b.name ? 1 : -1;
      });
      this.loaded.lists = true;
      this.loadingData.lists = false;
      this.loadingData.set('lists', false);
      this.updateLists.next(true);
      this.updateData.next({
        type: 'lists',
        data: [...this.lists]
      });
      // }, 500);
    }, 'name');

  }

  async getFlows() {

    let data: any = [];
    if (this.unsubscribeData.flows) {
      this.unsubscribeData.flows();
    }
    this.loaded.flows = -1;
    this.loadingData.flows = true;
    this.loadingData.set('flows', true);
    this.unsubscribeData.flows = this.dbSvc.getSubcollectionSnapshot('clients/' + this.selectedClient.id, 'flows', async (ref: any) => {
      const flows: any[] = [];
      ref.forEach((flowRef: any) => {
        const flow = flowRef.data();
        if (flow.id) {
          this.dbSvc.queryCollectionCount(
            'clients/' + this.selectedClient.id + '/profiles',
            [
              {
                fld: 'lists',
                op: 'array-contains',
                val: flow.id
              }
            ]
          ).then((count: any) => {
            flow.profiles_count = count.data().count;
            flows.push(flow);
          });
        }
      });
      // setTimeout(() => {
      //   const running = flows.filter(flow => flow.stats && flow.stats.mta_enqueued);
      //   const inactive = flows.filter(flow => !flow.stats || !flow.stats.mta_enqueued);
      //   this.flows = [...running, ...inactive];
      //   this.loaded.flows = true;
      //   this.loadingData.set('flows', false);
      //   // this.loadingData.flows = false;
      //   this.updateData.next({
      //     type: 'flows',
      //     data: [...this.flows]
      //   });
      // }, 500);
      this.flows = flows;
      this.loaded.flows = true;
      this.loadingData.set('flows', false);
      // this.loadingData.flows = false;
      this.updateData.next({
        type: 'flows',
        data: [...this.flows]
      });
    });

  }

  async getProfilesSummary() {
    if (!this.dbData.profiles.total || this.selectedClient.id !== this.queries.profiles.client) {
      let countRef = await this.dbSvc.getCollectionCount('clients/' + this.selectedClient.id + '/profiles');
      this.dbData.profiles.total = countRef.data().count;
      countRef = await this.dbSvc.queryCollectionCount('clients/' + this.selectedClient.id + '/profiles', 'consent', '==', true);
      this.dbData.profiles.total_consent = countRef.data().count;
    }
    this.loadingData.profiles = false;
    this.loadingData.set('profiles', false);
  }

  searchProfile(filters: any) {
    console.log('🚀 ~ AppService ~ searchProfile ~ filters:', filters);

    // Retornar el Observable directamente
    return this.server.get(
      'https://fullsearch-fqnphqcifq-ew.a.run.app/fs/' + this.selectedClient.id,
      filters
    ).pipe(
      map((res: any) => {
        if (res.result) {
          let profiles: any = [];
          const data = Object.values(res.data.rows);
          data.forEach((profile: any, idx: number) => {
            if (profile) {
              if ((!profile.first_name || profile.first_name == '') && (profile.name && profile.name > '')) {
                profile.first_name = profile.name;
              }
              profiles.push(profile);
            }
          });
          return profiles;
        }
        return [];
      })
    );
  }

  async getProfiles(page: any = 0, query: any = false, order: any = '', pageSize = 50) {

    if (this.loadingProfiles ||
      (page == this.queries.profiles.page &&
        query == this.queries.profiles.query &&
        order == this.queries.profiles.order &&
        pageSize == this.queries.profiles.pageSize &&
        this.selectedClient.id == this.queries.profiles.client)
    ) {
      if (!this.loadingProfiles) {
        this.stopSpinner();
      }
      return;
    }
    this.loaded.profiles = -1;
    this.loadingProfiles = true;
    this.queries.profiles = {
      page,
      query,
      order,
      pageSize,
      client: this.selectedClient.id
    };

    // if (!this.dbData.profiles.total) {
    let countRef = await this.dbSvc.getCollectionCount('clients/' + this.selectedClient.id + '/profiles');
    this.dbData.profiles.total = countRef.data().count;
    countRef = await this.dbSvc.queryCollectionCount('clients/' + this.selectedClient.id + '/profiles', 'consent', '==', true);
    this.dbData.profiles.total_consent = countRef.data().count;
    // }
    if (!this.dbData.profiles.pages) {
      this.dbData.profiles.pages = [];
    }
    if (order == '') {
      order = 'email';
    }
    const limit = pageSize;
    let last = this.dbData.profiles.pages[page] || false;
    if (this.unsubscribeData.profiles) {
      this.unsubscribeData.profiles();
    }
    this.loadingData.profiles = true;
    this.loadingData.set('profiles', true);
    if (!query || (Array.isArray(query))) {
      this.dbData.profiles.totalFiltered = 0;
      if (this.unsubscribeData.profiles) {
        this.unsubscribeData.profiles();
      }
      if (query !== false && (Array.isArray(query) && query.length > 0)) {
        let countRef = await this.dbSvc.queryCollectionCount('clients/' + this.selectedClient.id + '/profiles', query[0].fld, query[0].op, query[0].val);
        this.dbData.profiles.total_list = countRef.data().count;
      } else {
        this.dbData.profiles.total_list = 0;
      }
      this.unsubscribeData.profiles = this.dbSvc.getSubcollectionSnapshot('clients/' + this.selectedClient.id, 'profiles', (ref: any) => {
        this.profiles = [];
        let ct = 0;
        ref.forEach((ref2: any) => {
          if (!this.dbData.profiles.pages.length) {
            this.dbData.profiles.pages.push(ref2);
          }
          this.dbData.profiles.last = ref2;
          const profile = ref2.data();
          if (profile.id !== ref2.id) {
            profile.id = ref2.id;
          }
          if ((!profile.first_name || profile.first_name == '') && (profile.name && profile.name > '')) {
            profile.first_name = profile.name;
          }
          this.profiles.push(profile);
          ct++;
        });
        if (page == this.dbData.profiles.pages.length - 1) {
          this.dbData.profiles.pages[page + 1] = this.dbData.profiles.last;
        }
        this.loaded.profiles = true;
        this.loadingData.profiles = false;
        this.loadingData.set('profiles', false);
        this.updateData.next({
          type: 'profiles',
          data: this.profiles
        });
        // this.getLists();
        this.loadingProfiles = false;
        this.stopSpinner();
      }, order, limit, last, query);
    } else {
      const params: any = {
        query: query,
        page: page,
        pagesize: pageSize,
      }
      if (query.query) {
        params.query = query.query;
        params.listId = query.listId;
      }
      this.subscriptions.add(
        this.server.get(
          'https://fullsearch-fqnphqcifq-ew.a.run.app/fs/' + this.selectedClient.id,
          params
        ).subscribe((res: any) => {
          if (res.result) {
            const data = Object.values(res.data.rows);
            this.profiles = [];
            this.dbData.profiles.totalFiltered = res.data.totalRows;
            data.forEach((profile: any, idx: number) => {
              // if (idx >= (page * limit) && idx < ((page + 1) * limit)) {
              if (profile) {
                if ((!profile.first_name || profile.first_name == '') && (profile.name && profile.name > '')) {
                  profile.first_name = profile.name;
                }
                this.profiles.push(profile);
              }
              // }
            });
          }
          this.loaded.profiles = true;
          this.loadingData.profiles = false;
          this.loadingProfiles = false;
          this.stopSpinner();
          this.loadingData.set('profiles', false);
          this.updateData.next({
            type: 'profiles',
            data: this.profiles
          });
        }),
        'getProfiles1'
      );
    }
  }

  async getTemplates() {
    this.loaded.templates = -1;
    this.loadingData.templates = true;
    this.loadingData.set('templates', true);
    this.templates = [];
    const data = await this.dbSvc.getSubcollection('clients/' + this.selectedClient.id, 'templates');
    data.forEach((template: any) => {
      const data = template.data();
      // data.visible = data.visible !== undefined ? data.visible : true;
      // if (data.visible) {
      this.templates.push({...data, visible: data.visible !== undefined ? data.visible : true});
      // this.templates.push({
      //   id: data.id,
      //   name: data.name,
      //   url: data.screenshot_url,
      //   html_body: data.html_body,
      //   editor: data.editor,
      //   txt_body: data.txt_body,
      //   template_version: data.template_version ? data.template_version : 1,
      //   created: data.creation_date,
      //   updated: data.updated,
      //   visible: (data.visible !== undefined ? data.visible : true),
      // });
      // }
    });
    this.loaded.templates = true;
    this.loadingData.templates = false;
    this.loadingData.set('templates', false);
    this.updateData.next({
      type: 'templates',
      data: this.templates
    });
  }

  async getPopups() {
    this.loaded.popups = -1;
    this.loadingData.popups = true;
    this.loadingData.set('popups', true);
    this.popups = [];
    const data = await this.dbSvc.getSubcollection('clients/' + this.selectedClient.id, 'popups');
    data.forEach((template: any) => {
      const data = template.data();
      this.popups.push({...data, visible: (data.visible !== undefined ? data.visible : true)});
      // this.popups.push({
      //   id: data.id,
      //   name: data.name,
      //   url: data.screenshot_url,
      //   html_body: data.html_body,
      //   editor: data.editor,
      //   txt_body: data.txt_body,
      //   template_version: data.template_version ? data.template_version : 1,
      //   created: data.creation_date,
      //   updated: data.updated,
      //   visible: (data.visible !== undefined ? data.visible : true),
      // });
      // this.popups.push(template.data());
    });
    this.loaded.popups = true;
    this.loadingData.popups = false;
    this.loadingData.set('popups', false);
    this.updateData.next({
      type: 'popups',
      data: this.popups
    });
  }

  getFields(force = false) {
    if (!this.allProfileColumns.length || force) {
      if (!this.selectedClient.id) {
        this.timeouts.add(
          setTimeout(() => {
            this.getFields();
          }, 1000),
          'getFields1'
        );
        return;
      }
      const url = 'https://checkprofilescronjob-fqnphqcifq-ew.a.run.app/getvars/';
      this.subscriptions.add(
        this.server
          .get(url + this.selectedClient.id)
          .subscribe((res: any) => {
            if (res.result) {
              this.allProfileColumns = res.vars.filter((v: any) => !['actions', 'flows', 'lists'].includes(v)).map((val: any) => {
                const profile: any = {
                  label: snakeCaseToHumanReadable(val),
                  value: val
                }
                return profile;
              });
              if (res.nested.shopify) {
                this.shopifyColumns = res.nested.shopify.vars.map((val: any) => {
                  const field: any = {
                    label: snakeCaseToHumanReadable(val),
                    value: 'shopify.' + val
                  }
                  return field;
                });
                this.allProfileColumnsLoaded = true;
              }
            }
          }),
        'getFields1'
      );
    }
  }

  parseIArule(rule: any, HL = false) {

    let parsed = rule;
    let parsedHL = parsed;
    let profilesRule = false;

    parsed = rule.replaceAll('profile in ', 'perfiles en ')
      .replaceAll('profile not_in ', 'perfiles no incluidos en ')
      .replaceAll(' before ', ' antes de ')
      .replaceAll(' after ', ' después de ')
      .replaceAll('==', ' es igual a ')
      .replaceAll('!=', ' es diferente de ')
      .replaceAll('>=', ' es mayor o igual que ')
      .replaceAll('>', ' es mayor que ')
      .replaceAll('<=', ' es menor o igual que ')
      .replaceAll('<', ' es menor que ')
      .replaceAll(' and ', ' y ')
      .replaceAll('&&', ' y ')
      .replaceAll(' or ', ' o ')
      .replaceAll('||', ' o ')
      .replaceAll('!(', ' No (');
    parsedHL = rule.replaceAll('profile in ', '[[span class="fld"]]perfiles en [[/span]]')
      .replaceAll('profile not_in ', '[[span class="fld"]]perfiles no incluidos en [[/span]]')
      .replaceAll(' before ', ' [[span class="cond"]]antes de[[/span]] ')
      .replaceAll(' after ', ' [[span class="cond"]]después de[[/span]] ')
      .replaceAll('==', ' [[span class="cond"]]es igual a[[/span]] ')
      .replaceAll('!=', ' [[span class="cond"]]es diferente de[[/span]] ')
      .replaceAll('>=', ' [[span class="cond"]]es mayor o igual que[[/span]] ')
      .replaceAll('>', ' [[span class="cond"]]es mayor que[[/span]] ')
      .replaceAll('<=', ' [[span class="cond"]]es menor o igual que[[/span]] ')
      .replaceAll('<', ' [[span class="cond"]]es menor que[[/span]] ')
      .replaceAll(' and ', ' [[span class="lop"]] y [[/span]] ')
      .replaceAll(' AND ', ' [[span class="lop"]] y [[/span]] ')
      .replaceAll('&&', ' [[span class="lop"]] y [[/span]] ')
      .replaceAll(' or ', ' [[span class="lop"]] o [[/span]] ')
      .replaceAll(' OR ', ' [[span class="lop"]] o [[/span]] ')
      .replaceAll('||', ' [[span class="lop"]] o [[/span]] ')
      .replaceAll('!(', ' [[span class="lop not"]]No[[/span]] (')
      .replaceAll('(', '[[span class="group"]]([[/span]]')
      .replaceAll(')', '[[span class="group"]])[[/span]]')
      ;

    const regexIds = /\"([^\"]+)\"/g;
    const regexNumbers = /\s([\d]+)[\s]+|\s([\d]+)$|^([\d])+\s/g;
    const regexBoolean = /\s([true|false|null]+)[\s]+|\s([true|false|null]+)$|^([true|false|null])+\s/g;
    const regexFlds = /[!]*profile\.[^\s]+/g
    const regexFuncs = /@[^(]+/g
    const regexDays = /[\'|\"]([\d]+d)[\'|\"]/g;
    const regexWeeks = /[\'|\"]([\d]+W)[\'|\"]/g;
    const regexMonths = /[\'|\"]([\d]+M)[\'|\"]/g;
    const regexYear = /[\'|\"]([\d]+Y)[\'|\"]/g;
    const regexHours = /[\'|\"]([\d]+h)[\'|\"]/g;
    const regexMinutes = /[\'|\"]([\d]+m)[\'|\"]/g;
    const regexSeconds = /[\'|\"]([\d]+s)[\'|\"]/g;
    const regexpDate = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/g;

    const ids: any = [...rule.matchAll(regexIds)];
    const numbers: any = [...rule.matchAll(regexNumbers)];
    const boolaeans: any = [...rule.matchAll(regexBoolean)];
    const flds: any = [...rule.matchAll(regexFlds)];
    const funcs: any = [...rule.matchAll(regexFuncs)];
    const days: any = [...rule.matchAll(regexDays)];
    const weeks: any = [...rule.matchAll(regexWeeks)];
    const months: any = [...rule.matchAll(regexMonths)];
    const years: any = [...rule.matchAll(regexYear)];
    const hours: any = [...rule.matchAll(regexHours)];
    const minutes: any = [...rule.matchAll(regexMinutes)];
    const seconds: any = [...rule.matchAll(regexSeconds)];
    const dates: any = [...rule.matchAll(regexpDate)];

    const realIds: any[] = [];
    if (rule.includes(' in ') || rule.includes(' not_in ')) {
      for (let i = 0, l = ids.length; i < l; i++) {
        const list: any = this.lists.filter((list: any) => {
          return list.id == ids[i][1];
        })[0];
        if (list && list.name !== undefined) {
          realIds.push(ids[i][0]);
          parsed = parsed.replaceAll(ids[i][1], list.name);
          parsedHL = parsedHL.replaceAll(ids[i][1], '[[span class="val"]]' + list.name + '[[/span]]');
        }
      }
    }

    for (let i = 0, l = numbers.length; i < l; i++) {
      parsedHL = parsedHL.replaceAll(numbers[i][0], '[[span class="val"]]' + numbers[i][0] + '[[/span]]');
    }

    for (let i = 0, l = funcs.length; i < l; i++) {
      parsedHL = parsedHL.replaceAll(funcs[i][0], '[[span class="func"]]' + funcs[i][0] + '[[/span]]');
    }

    for (let i = 0, l = boolaeans.length; i < l; i++) {
      const result = boolaeans[i][0].trim() == 'true' ? 'verdadero' : 'falso';
      parsedHL = parsedHL.replaceAll(boolaeans[i][0], '[[span class="val"]]' + result + '[[/span]]');
    }

    const allColumns = [...this.allProfileColumns, ...this.shopifyColumns];
    for (let i = 0, l = flds.length; i < l; i++) {
      let needParse = false;
      // let fld: any = allColumns.filter(v => v.value == flds[i][0].split('.')[1]);
      let fld: any = allColumns.filter((v: any) => {
        const val = flds[i][0].split('.')
          .reduce((acc: any, v2: any, i: any) => {
            if (i > 0) {
              if (i > 1) {
                v2 = '.' + v2;
              }
              return acc + v2;
            }
            return acc + '';
          }, '');
        const ret = v.value == val;
        return ret;
      });
      if (fld.length) {
        fld = fld[0];
        let label = '"' + fld.label + '"';
        if (flds[i][0].trim().substring(0, 1) == '!' || flds[i][0].substring(0, 2) == '(!') {
          label = '"[[span class="not"]]No [[/span]]' + fld.label + '"';
        }
        parsed = parsed.replaceAll(flds[i][0], label);
        parsedHL = parsedHL.replaceAll(flds[i][0], '[[span class="fld"]]' + label + '[[/span]]');
      } else {
        let value = flds[i][0].split('.')[flds[i][0].split('.').length - 1];
        let pref = '';
        if (flds[i][0].trim().substring(0, 1) == '!') {
          pref = '[[span class="not"]]No [[/span]]';
        }
        parsedHL = parsedHL.replaceAll(flds[i][0].replace(')', ''), '[[span class="fld"]]"' + pref + snakeCaseToHumanReadable(value) + '"[[/span]]');
      }
    }

    for (let i = 0, l = days.length; i < l; i++) {
      let day: any = days[i];
      parsed = parsed.replaceAll(day[0], day[0].replace('d', ' días').replaceAll("'", ''));
      parsedHL = parsedHL.replaceAll(day[0], '[[span class="val"]]' + day[0].replace('d', ' días').replaceAll("'", '') + '[[/span]]');
    }
    for (let i = 0, l = weeks.length; i < l; i++) {
      let week: any = weeks[i];
      parsed = parsed.replaceAll(week[0], week[0].replace('W', ' semanas').replaceAll("'", ''));
      parsedHL = parsedHL.replaceAll(week[0], '[[span class="val"]]' + week[0].replace('W', ' semanas').replaceAll("'", '') + '[[/span]]');
    }
    for (let i = 0, l = months.length; i < l; i++) {
      let month: any = months[i];
      parsed = parsed.replaceAll(month[0], month[0].replace('M', ' meses').replaceAll("'", ''));
      parsedHL = parsedHL.replaceAll(month[0], '[[span class="val"]]' + month[0].replace('M', ' meses').replaceAll("'", '') + '[[/span]]');
    }
    for (let i = 0, l = years.length; i < l; i++) {
      let year: any = years[i];
      parsed = parsed.replaceAll(year[0], year[0].replace('Y', ' años').replaceAll("'", ''));
      parsedHL = parsedHL.replaceAll(year[0], '[[span class="val"]]' + year[0].replace('Y', ' años').replaceAll("'", '') + '[[/span]]');
    }

    for (let i = 0, l = hours.length; i < l; i++) {
      let hour: any = hours[i];
      parsed = parsed.replaceAll(hour[0], hour[0].replace('h', ' horas').replaceAll("'", ''));
      parsedHL = parsedHL.replaceAll(hour[0], '[[span class="val"]]' + hour[0].replace('h', ' horas').replaceAll("'", '') + '[[/span]]');
    }
    for (let i = 0, l = minutes.length; i < l; i++) {
      let minute: any = minutes[i];
      parsed = parsed.replaceAll(minute[0], minute[0].replace('m', ' minutos').replaceAll("'", ''));
      parsedHL = parsedHL.replaceAll(minute[0], '[[span class="val"]]' + minute[0].replace('m', ' minutos').replaceAll("'", '') + '[[/span]]');
    }
    for (let i = 0, l = seconds.length; i < l; i++) {
      let second: any = seconds[i];
      parsed = parsed.replaceAll(second[0], second[0].replace('s', ' segundos').replaceAll("'", ''));
      parsedHL = parsedHL.replaceAll(second[0], '[[span class="val"]]' + second[0].replace('s', ' segundos').replaceAll("'", '') + '[[/span]]');
    }

    for (let i = 0, l = dates.length; i < l; i++) {
      let date: any = dates[i];
      let dateStruct = date[0].split('T');
      dateStruct[0] = this.mirrorDate(dateStruct[0]);
      let dateVal = dateStruct[0];
      if (dateStruct[1].substring(0, 5) !== '00:00') {
        dateVal += ' ' + dateStruct[1].substring(0, 5);
      }
      parsed = parsed.replaceAll(date[0], dateVal);
      parsedHL = parsedHL.replaceAll(date[0], '[[span class="val"]]' + dateVal + '[[/span]]');
    }

    for (let i = 0, l = ids.length; i < l; i++) {
      let id: any = ids[i];
      if (!realIds.includes(id) &&
        // !hours.includes(id) &&
        // !minutes.includes(id) &&
        // !seconds.includes(id) &&
        // !days.includes(id) &&
        // !weeks.includes(id) &&
        // !months.includes(id) &&
        // !years.includes(id) &&
        // !flds.includes(id) &&
        // !dates.includes(id) &&
        !hours.filter((v: any) => v.filter((v2: any) => v2 == id[0]).length).length &&
        !minutes.filter((v: any) => v.filter((v2: any) => v2 == id[0]).length).length &&
        !seconds.filter((v: any) => v.filter((v2: any) => v2 == id[0]).length).length &&
        !days.filter((v: any) => v.filter((v2: any) => v2 == id[0]).length).length &&
        !weeks.filter((v: any) => v.filter((v2: any) => v2 == id[0]).length).length &&
        !months.filter((v: any) => v.filter((v2: any) => v2 == id[0]).length).length &&
        !years.filter((v: any) => v.filter((v2: any) => v2 == id[0]).length).length &&
        !flds.filter((v: any) => v.filter((v2: any) => v2 == id[0]).length).length &&
        !dates.filter((v: any) => v.filter((v2: any) => v2 == id[0]).length).length
      ) {
        parsedHL = parsedHL.replaceAll(id[0], '[[span class="val"]]' + id[0] + '[[/span]]');
      }
    }

    parsedHL = parsedHL.replaceAll('[[', '<').replaceAll(']]', '>');

    return HL ? parsedHL : parsed;

  }

  addProfile(list = false) {
    return new Observable((observer) => {
      this.subscriptions.add(
        this.dlgsSvc.prompt(
          'Nuevo perfil',
          'Introduzca los datos del nuevo perfil',
          [
            {
              key: 'first_name',
              label: 'Nombre',
              type: 'text'
            },
            {
              key: 'last_name',
              label: 'Apellidos',
              type: 'text'
            },
            {
              key: 'email',
              label: 'E-Mail',
              type: 'text',
              validation: {
                required: true,
                email: true
              },
              validationMessages: {
                required: 'Debe introducir un correo electrónico',
                email: 'El valor introducido no es un email válido'
              }
            },
            {
              key: 'consent',
              label: 'Consent',
              type: 'checkbox'
            },
          ]
        ).subscribe(async (res: any) => {
          if (res) {
            const profile = res;
            const keys = Object.keys(profile);
            for (let i = 0, l = keys.length; i < l; i++) {
              if (profile[keys[i]] === undefined) {
                delete profile[keys[i]];
              }
            }
            if (list) {
              profile.lists = [list];
            }
            if (profile.lists && profile.lists.length == 0) {
              delete profile['lists'];
            }
            if (!profile.id) {
              profile.id = this.generateRandomString(7, 'P');
              let exists = await this.dbSvc.checkId('clients/' + this.selectedClient.id + '/profiles', profile.id);
              while (exists) {
                profile.id = this.generateRandomString(7, 'P');
                exists = await this.dbSvc.checkId('clients/' + this.selectedClient.id + '/profiles', profile.id);
              }
            }
            this.dbSvc.updateSubcollection('clients/' + this.selectedClient.id, 'profiles', profile).then((res: any) => {
              observer.next({
                result: true,
                data: profile
              });
            });
          }
        }),
        'addProfile1'
      );
    });
  }

  mirrorDate(date: string, target = 'dd-mm-yyyy') {
    const parts = date.split('-');
    return parts[2] + '-' + parts[1] + '-' + parts[0];
  }

  sortByCreatedUpdated(a: any, b: any) {
    let ret = 0;
    if (a.created && b.created) {
      if (a.created > b.created) {
        ret = -1;
      } else if (a.created < b.created) {
        ret = 1;
      }
    } else if (a.created) {
      ret = -1;
    } else {
      ret = -1;
    }
    if (a.updated && b.updated) {
      if (a.updated > b.updated) {
        ret = -1;
      } else if (a.updated < b.updated) {
        ret = 1;
      }
    } else if (a.updated) {
      ret = -1;
    } else if (b.updated) {
      ret = 1;
    }
    return ret;
  }

  validateSender(sender: any) {
    const url = 'https://fl.nvio.ai/sendverification/' + this.selectedClient.id + '/' + sender.email;
    this.subscriptions.add(
      this.server.get(url).subscribe((res: any) => {
        // if (res) {
        // }
      }),
      'validateSender1'
    );
  }

  sendProfilesFile(file: any, list_id: string = "no-list", consent: any = false) {

    const fd = new FormData();
    // let url = `https://europe-west1-mail-automation-b4f6d.cloudfunctions.net/clientActions/profiles-csv/` + this.selectedClient.id + '/' + list_id;
    let url = `https://ca.nvio.ai/profiles-csv/` + this.selectedClient.id + '/' + list_id;
    if (consent) {
      url += '/consent';
    }
    fd.append('file', file);
    this.subscriptions.add(
      this.server.upload(
        url,
        fd
      ).subscribe((res: any) => {
        this.sendingProfiles = false;
        this.spinnerSvc.hide();
        let text = '';
        if (res.result && (!res.data.errors || !res.data.errors.length)) {
          text = 'El fichero se ha subido correctamente.';
          if (res.data.added) {
            text += '<p>Se han añadido ' + res.data.added + ' perfiles</p>'
          }
          if (res.data.updated) {
            text += '<p>Se han actualizado ' + res.data.updated + ' perfiles</p>'
          }
        } else if (res.data.errors && res.data.errors.length) {
          text = 'Se han producido errores al interpretar el fichero.';
          const max_errors = 5;
          text += '<ul>';
          for (let i = 0, l = res.data.errors.length; i < l; i++) {
            if (i >= max_errors) {
              break;
            }
            text += '<li>' + res.data.errors[i] + '</li>';
          }
          if (res.data.errors.length > max_errors) {
            text += '<li>...</li>'
          }
          text += '</ul>';
        }
        this.dlgsSvc.confirm(
          'Importación de perfiles',
          text,
          'Cerrar'
        ).subscribe(_ => { });
      }),
      'sendProfilesFile1'
    );

  }

  callCF(url: string, params: any = '', method = 'GET') {
    // const url = 'https://fl.nvio.ai/sendverification/' + this.selectedClient.id + '/' + sender.email;
    const xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.onload = () => {
      if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 400) {
          const response = JSON.parse(xhr.responseText);
        }
      }
    };
    if (typeof params === 'object' && params !== null) {
      params = new URLSearchParams(params).toString();
    }
    if (params > '') {
      xhr.send(params);
    } else {
      xhr.send();
    }
  }

  cloudFunction(url: string, params: any = '', method = 'GET'): Promise<any> {
    // const url = 'https://fl.nvio.ai/sendverification/' + this.selectedClient.id + '/' + sender.email;
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open(method, url, true);
      xhr.onload = () => {
        if (xhr.readyState === 4) {
          if (xhr.status != 422 && xhr.status >= 200 && xhr.status < 400) {
            const response = JSON.parse(xhr.responseText);
            resolve({
              status: xhr.status,
              response: response
            });
          } else {
            resolve({
              status: xhr.status,
              response: xhr.responseText
            });
          }
        }
      };
      xhr.onerror = (error) => {
        resolve({
          result: false
        });
      };
      xhr.onabort = (response) => {
      }
      if (typeof params === 'object' && params !== null) {
        params = new URLSearchParams(params).toString();
      }
      try {
        if (params > '') {
          xhr.send(params);
        } else {
          xhr.send();
        }
      } catch (error) {
        resolve({
          status: 500,
          response: error
        });
      }
    });
  }

  generateRandomString = (num: number, prefix = '') => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result1 = prefix;
    const charactersLength = characters.length;
    for (let i = 0, l = num - result1.length; i < l; i++) {
      result1 += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result1;
  }

  generateHash(str: string, seed = 0): string {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
      ch = str.charCodeAt(i);
      h1 = Math.imul(h1 ^ ch, 2654435761);
      h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

    return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString();
  }

  sanitizePastedString(str: string) {
    return str.replace(/\0[\s\S]*$/g, '');
  }

  parseISOString(s: string) {
    var b: any[] = s.split(/\D+/);
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
  }

  relativeFullDate(date: any, include_hour = false, short = false): string {
    if ((typeof date).toLowerCase() === 'string') {
      date = this.parseISOString(date);
    }
    const today = new Date();
    const startOfWeek = new Date(today);
    const hour = (date as Date).getHours();
    const minutes = (date as Date).getMinutes();

    startOfWeek.setDate(today.getDate() - today.getDay()); // Retrocede al primer día de la semana (lunes)

    // const diff = Math.floor((today.getTime() - date.getTime()) / (1000 * 3600 * 24));
    const diff = Math.floor((today.getDate() - date.getDate()));
    let ret = '';

    let date_length = (short ? 'short' : 'long');

    if (diff === 0) {
      ret = 'Hoy';
    } else if (diff === 1) {
      ret = 'Ayer';
    } else if (diff >= 2 && (today.getDay() - diff) > 1) {
      const options: any = { weekday: date_length };
      ret = 'El ' + date.toLocaleDateString('es-ES', options);
    } else {
      // Si es lunes o el día actual es lunes, devuelve la fecha completa
      const options: any = { weekday: date_length, day: 'numeric', month: date_length };
      ret = date.toLocaleDateString('es-ES', options);
    }

    if (include_hour) {
      ret += ' (' + hour.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ')';
    }

    return ret;

  }

  logout() {
    this.afAuth.signOut().then((res: any) => {
      this.auth = {};
    });
  }

}
